module.exports = __webpack_public_path__ + "static/media/profileHeader.17f336f0.jpg";